const rosterPositions =
  [
    'left',
    'center',
    'right',
    'defense',
    'goalie',
    'utility',
  ];

export default rosterPositions;